/**
 * @function errorHandler - обрабатывает ошибку инициализации карты на маршрутах
 * @param {string} error - сообщение об ошибке
 * */

export default function errorHandler(error) {
    document.getElementById('map').remove();

    console.error(error);
}
